import StoryNavPanel from './NavPanel';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StorySidePanel = function StorySidePanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onScroll = _ref.onScroll,
      setSidePanelRef = _ref.setSidePanelRef,
      panelLayout = _ref.panelLayout,
      theme = _ref.theme,
      activeSection = _ref.activeSection,
      activeStep = _ref.activeStep,
      setJumpSection = _ref.setJumpSection,
      contentSize = _ref.contentSize,
      hideNavigation = _ref.hideNavigation,
      navigationIcons = _ref.navigationIcons;
  useEffect(function () {
    setSidePanelRef(sidePanelRef);
  }, []);
  useEffect(function () {
    var sidePanelNodes = Array.from(sidePanelRef.current.childNodes);

    if (activeStep !== activeSection) {
      if (activeStep === -1) {
        var _sidePanelRef$current;

        sidePanelRef !== null && sidePanelRef !== void 0 && (_sidePanelRef$current = sidePanelRef.current) !== null && _sidePanelRef$current !== void 0 && _sidePanelRef$current.scrollTo({
          top: sidePanelNodes[sidePanelNodes.length - 1].offsetTop
        }), setJumpSection(sidePanelNodes.length - 1);
      } else {
        var _sidePanelRef$current2;

        sidePanelRef !== null && sidePanelRef !== void 0 && (_sidePanelRef$current2 = sidePanelRef.current) !== null && _sidePanelRef$current2 !== void 0 && _sidePanelRef$current2.scrollTo({
          top: sidePanelNodes[activeStep].offsetTop
        }), setJumpSection(activeStep);
      }
    }
  }, [activeStep]);
  var sidePanelRef = useRef();

  var classes = function classes(name) {
    return classnames(name, {}, 'is-' + panelLayout + '-layout', className);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classes('ptr-StorySidePanel-container'),
    children: [sidePanelRef.current && !hideNavigation ? /*#__PURE__*/_jsx(StoryNavPanel, {
      activeSection: activeSection,
      setJumpSection: setJumpSection,
      sidePanelRef: sidePanelRef,
      contentSize: contentSize,
      theme: theme,
      navigationIcons: navigationIcons
    }) : null, /*#__PURE__*/_jsx("div", {
      className: classes('ptr-StorySidePanel'),
      style: hideNavigation ? {
        width: '100%',
        paddingLeft: '1rem'
      } : !sidePanelRef.current ? {
        marginLeft: '2.5rem'
      } : {},
      ref: sidePanelRef,
      onScroll: onScroll,
      children: children
    })]
  });
};

StorySidePanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onScroll: PropTypes.func,
  setSidePanelRef: PropTypes.func,
  panelLayout: PropTypes.string,
  activeSection: PropTypes.number,
  setJumpSection: PropTypes.func,
  contentSize: PropTypes.number,
  theme: PropTypes.string,
  hideNavigation: PropTypes.bool,
  navigationIcons: PropTypes.object,
  activeStep: PropTypes.number
};
export default StorySidePanel;